import React, { useEffect } from "react";
import LeaderLine from "react-leader-line";
import { useStateIfMounted } from "use-state-if-mounted";
import "./../../../css/app.css";
import mqtt_topics from "./../../../mqtt/mqtt_topics";
import Chart from "./chart";
import useCheckMobileScreen from "./useCheckMobileScreen";
import WeatherWidget from "./WeatherWidget";
const mqtt = require("../../../mqtt/mqtt.js");

localStorage.setItem("designtype", "FSHYB");
localStorage.setItem("type", "amfes");

const COND05 = (props) => {
  let mqttClient;
  const offlinetimeout = 60;
  let isMobile = useCheckMobileScreen();
  let fistupdate = true;
  let vectorSize = useCheckMobileScreen() ? 2 : 4;
  let diagramFontSize = useCheckMobileScreen() ? { fontSize: "12px" } : {};
  let vectors = {};
  const isfuelsaver = true;
  const [state, setState] = useStateIfMounted({
    surftype: "", //"AMFES"
    gstatus: "", //"Feeding The Load"
    grunning: "", //true
    gonload: "", //true
    ustatus: "", // "Utility Absent"
    urunning: "", //false
    uonload: "", //false
    Load: "",
    GPower: "",
    UPower: "",
    Inverter: "",
    PV: "",
    BatCurrent: "",
    BatCapacity: "",
    siteid: "COND05",
    mac: "0-6d-52", //"0-5a-48", //"0-67-2c", //COND05 state.macaddress; "0-6d-52"
    online: true,
    MinSoC: "",
    BatCap: "",
  });
  const diagramtopic =
    mqtt_topics.fixed_topic_part + state.mac + "/" + mqtt_topics.diagram_topic;

  function checkifemptystateofdata() {
    if (state.surftype == "" || state.surftype == undefined) {
      return true;
    }
    return false;
  }

  function requestdata() {
    mqtt_topics.busy_Requesting_Data = true;
    mqttClient.publish(
      mqtt_topics.fixed_topic_part + state.mac + mqtt_topics.request_topic,
      mqtt_topics.diagram_topic
    );
    mqtt_topics.busy_Requesting_Data = false;
    mqttClient.subscribe(diagramtopic);
    mqttClient.on("message", handleMqttMessage);
  }

  function handleMqttMessage(topic, message) {
    if (topic == diagramtopic) {
      try {
        // message is Buffer
        message = JSON.parse(message.toString());
        setState({
          ...state,
          surftype: message.Type == undefined ? "" : message.Type,
          gstatus: message.gstatus == undefined ? "" : message.gstatus,
          grunning: message.grunning == 0 ? false : true,
          gonload: message.gonload == 0 ? false : true,
          ustatus: message.ustatus,
          urunning: message.urunning == 0 ? false : true,
          uonload: message.uonload == 0 ? false : true,
          Load: message.Load == undefined ? "" : Number(message.Load),
          UPower: message.UPower == undefined ? "0" : message.UPower,
          GPower: message.GPower == undefined ? "0" : message.GPower,
          Inverter: message.Inverter == undefined ? "0" : message.Inverter,
          PV: message.PV == undefined ? "0" : Number(message.PV),
          BatCurrent:
            message.BatCurrent == undefined
              ? message.BatPower == undefined
                ? "0"
                : Number(message.BatPower)
              : Number(message.BatCurrent),
          BatCapacity:
            message.BatCapacity == undefined
              ? "0"
              : Number(message.BatCapacity),
          MinSoC: message.MinSoC == undefined ? "" : message.MinSoC,
          BatCap: message.BatCap == undefined ? "" : message.BatCap,
          online: true,
        });
        ////console.log(message.Type, message.gstatus, message.grunning);
        ////console.log(message.gstatus, "From Surf Mode: " + message.gstatus);
      } catch (error) {
        ////console.log(message);
      }
      if (!fistupdate && isfuelsaver) {
        // Add new leader line from `start` to `end` (HTML/SVG element, basically)
        createAndUpdateVectors(
          "towercell",
          "loadcell",
          message.uonload == 0 ? false : true,
          "grid",
          "right",
          "right"
        );
        createAndUpdateVectors(
          message.UPower > 0 ? "towercell" : "inverter",
          message.UPower > 0 ? "inverter" : "towercell",
          message.uonload == 0 ? false : true,
          "grid",
          message.UPower > 0 ? "right" : "top",
          message.UPower > 0 ? "top" : "right",
          message.UPower > 0 ? message.UPower + " kW Imported" : "",
          "",
          message.UPower < 0
            ? (+message.UPower + +message.Load) * -1 + " kW Exported"
            : ""
        );
        createAndUpdateVectors(
          "generatorcell",
          "inverter",
          (message.gonload == 0 ? false : true) &&
            message.BatPower - message.PV > 0,
          "grid",
          "left",
          "top",
          "",
          "",
          !isNaN((100 - (message.Load * 100) / message.GPower).toFixed(0))
            ? (100 - (message.Load * 100) / message.GPower).toFixed(0) +
                "%" +
                (isMobile ? "" : " Stored")
            : "",
          [2, -30]
        );
        createAndUpdateVectors(
          "generatorcell",
          "loadcell",
          message.gonload == 0 ? false : true,
          "grid",
          "left",
          "top",
          message.GPower + " kW produced",
          "",
          message.BatPower - message.PV < 0
            ? "100%"
            : !isNaN(((message.Load * 100) / message.GPower).toFixed(0))
            ? ((message.Load * 100) / message.GPower).toFixed(0) +
              "%" +
              (isMobile ? "" : " Consumed")
            : "",
          [2, -30]
        );
        createAndUpdateVectors(
          (message.BatCurrent == undefined
            ? message.BatPower == undefined
              ? "0"
              : Number(message.BatPower)
            : Number(message.BatCurrent)) > 0
            ? "inverter"
            : "battery",
          (message.BatCurrent == undefined
            ? message.BatPower == undefined
              ? "0"
              : Number(message.BatPower)
            : Number(message.BatCurrent)) > 0
            ? "battery"
            : "inverter",
          true,
          "straight",
          (message.BatCurrent == undefined
            ? message.BatPower == undefined
              ? "0"
              : Number(message.BatPower)
            : Number(message.BatCurrent)) > 0
            ? "bottom"
            : "top",
          (message.BatCurrent == undefined
            ? message.BatPower == undefined
              ? "0"
              : Number(message.BatPower)
            : Number(message.BatCurrent)) > 0
            ? "top"
            : "bottom"
        );
        createAndUpdateVectors(
          "pv",
          "inverter",
          message.PV > 0 ? true : false,
          "straight",
          "left",
          "right"
        );
        createAndUpdateVectors(
          "inverter",
          "loadcell",
          (!(message.gonload == 0 ? false : true) &&
            !(message.uonload == 0 ? false : true)) ||
            message.BatPower - message.PV < 0,
          "straight",
          "left",
          "right"
        );
      } else {
        fistupdate = false;
      }
    } else if (
      topic ==
      mqtt_topics.fixed_topic_part + state.mac + mqtt_topics.stillpresent_topic
    ) {
      //console.log("recieved user presence");
      if (!mqtt_topics.busy_Requesting_Data) {
        returnuserpresence();
      } else {
        setTimeout(function () {
          returnuserpresence();
        }, mqtt_topics.timeouttotrytorequestmqttdata);
      }
    }
    mqtt_topics.lasttimegotlivedata = Math.floor(Date.now() / 1000);
  }
  useEffect(() => {
    fistupdate = true;
    mqtt_topics.categories_User_Iswatching = [
      '"Close ' + mqtt_topics.diagram_topic + '"',
    ];
    mqttClient = mqtt.connect();
    mqttClient.setMaxListeners(0);

    mqttClient.subscribe(
      mqtt_topics.fixed_topic_part + state.mac + mqtt_topics.stillpresent_topic
    );

    if (!mqtt_topics.busy_Requesting_Data) {
      requestdata();
    } else {
      setTimeout(function () {
        requestdata();
      }, mqtt_topics.timeouttotrytorequestmqttdata); //wait 1 seconds
    }
    clearsallvectors();
    const interval = setInterval(() => {
      keepcheckingifoffline();
    }, 10000);
    return () => clearInterval(interval);
  }, []);

  function calculateChargingOrDischargingTime() {
    let time;
    let label;

    // --- Detect equalizing ---
    const isEqualizing =
      state.BatCurrent > 0 && // AC charging connected
      state.BatCurrent < 1 && // Current below threshold
      state.BatCapacity >= 95; // High SoC

    if (isEqualizing) {
      return "Battery full (equalizing)";
    }

    if (state.BatCurrent > 0) {
      // --- Charging ---
      let taperFactor = 1;

      if (state.BatCapacity > 90) {
        // Smooth taper between 90–95%
        // At 90% → taperFactor = 1
        // At 95% → taperFactor = 0.3 (example)
        //const soc = state.BatCapacity;
        //taperFactor = 1 - ((soc - 90) / 5) * 0.7; // 90%→1, 95%→0.3
        const socRatio = (state.BatCapacity - 90) / 7; // 90–97% → 0–1
        taperFactor = Math.pow(1 - socRatio, 2); // quadratic
        if (taperFactor < 0.2) taperFactor = 0.2; // never drop below 0.2
      }

      time =
        ((state.BatCap * (1 - state.BatCapacity / 100)) / state.BatCurrent) *
        taperFactor;
      label = "Time to full charge: ";
    } else {
      // --- Discharging ---
      time =
        (state.BatCap * ((state.BatCapacity - state.MinSoC) / 100)) /
        Math.abs(state.BatCurrent);
      label = "Time to discharge: ";
    }

    // Convert time (in hours) to hh:mm
    const hours = Math.floor(Math.abs(time));
    const minutes = Math.floor((Math.abs(time) - hours) * 60);

    return (
      label +
      `${hours.toString().padStart(2, "0")}h ${minutes
        .toString()
        .padStart(2, "0")}m`
    );
  }

  function returnuserpresence() {
    mqtt_topics.busy_Requesting_Data = true;
    mqttClient.publish(
      mqtt_topics.fixed_topic_part + state.mac + mqtt_topics.request_topic,
      "User Alive"
    );
    mqtt_topics.busy_Requesting_Data = false;
  }

  useEffect(() => {
    window.onbeforeunload = (e) => {
      handlepageexixt();
    };
  }, []);

  function handlepageexixt() {
    mqttClient.unsubscribe(diagramtopic);
    mqttClient.unsubscribe(
      mqtt_topics.fixed_topic_part + state.mac + mqtt_topics.stillpresent_topic
    );
    mqttClient.removeListener("message", handleMqttMessage);
    mqttClient.publish(
      mqtt_topics.fixed_topic_part + state.mac + mqtt_topics.request_topic,
      JSON.parse(
        JSON.stringify(
          '{ "' +
            mqtt_topics.finishedofalllivereadings +
            '" : [' +
            mqtt_topics.categories_User_Iswatching +
            "] }"
        )
      )
    );
    clearsallvectors();
    // I'm about to refresh! do something...
    if (mqttClient != undefined && mqttClient.connected) {
      mqttClient.end();
    }
  }

  function keepcheckingifoffline() {
    let now = Math.floor(Date.now() / 1000);
    if (now - mqtt_topics.lasttimegotlivedata > offlinetimeout) {
      clearsallvectors();
      setState({ ...state, online: false });
    }
  }

  //when componenet unmount
  useEffect(
    () => () => {
      handlepageexixt();
      clearsallvectors();
      //console.log("diagram component unmount");
    },
    []
  );

  function clearsallvectors() {
    Object.keys(vectors).map(function (key) {
      try {
        vectors[key].remove();
      } catch (Exception) {
        //console.log(Exception);
      }
    });
    vectors = {};
  }

  function displayled(where) {
    switch (where) {
      case "urunning": {
        if (state.urunning) {
          return require("./../../../images/diagram/normal/red_onIndicator.png");
        }
        return require("./../../../images/diagram/normal/red_offIndicator.png");
      }
      case "uonload": {
        if (state.uonload) {
          return require("./../../../images/diagram/normal/green_onIndicator.png");
        }
        return require("./../../../images/diagram/normal/green_offIndicator.png");
      }
      case "grunning": {
        if (state.grunning) {
          return require("./../../../images/diagram/normal/red_onIndicator.png");
        }
        return require("./../../../images/diagram/normal/red_offIndicator.png");
      }
      case "gonload": {
        if (state.gonload) {
          return require("./../../../images/diagram/normal/green_onIndicator.png");
        }
        return require("./../../../images/diagram/normal/green_offIndicator.png");
      }
    }
  }

  function createAndUpdateVectors(
    from,
    to,
    onload,
    path,
    startSocket,
    endSocket,
    startLabel,
    middleLabel,
    endLabel,
    offset
  ) {
    if (
      document.getElementById(from) != undefined &&
      document.getElementById(to) != undefined
    ) {
      if (onload) {
        let options = {
          startPlugColor: "#1a6be0",
          endPlugColor: "#1efdaa",
          gradient: true,
          dash: { animation: true },
          path: path,
          startSocket: startSocket,
          endSocket: endSocket,
          //endPlugSize: vectorEndPlugSize,
          size: vectorSize,
          startLabel: LeaderLine.captionLabel(startLabel, {
            color: "#1a6be0",
          }),
          middleLabel: middleLabel,
          endLabel: LeaderLine.captionLabel(endLabel, {
            color: "#1efdaa",
            offset: offset,
          }),
        };
        if (vectors[from + to] != undefined) {
          try {
            vectors[from + to].setOptions(options);
          } catch (Exception) {
            //console.log(Exception);
            vectors[from + to] = new LeaderLine(
              document.getElementById(from),
              document.getElementById(to),
              options
            );
          }
        } else {
          vectors[from + to] = new LeaderLine(
            document.getElementById(from),
            document.getElementById(to),
            options
          );
        }
      } else {
        if (vectors[from + to] !== undefined) {
          try {
            vectors[from + to].remove();
          } catch (Exception) {
            //console.log(Exception);
          }
        }
      }
      if (vectors[to + from] !== undefined) {
        try {
          vectors[to + from].remove();
        } catch (Exception) {
          //console.log(Exception);
        }
      }
    }
  }

  function round20(x) {
    //return Math.ceil(x / 20) * 20; //round up
    //return Math.round(x / 20) * 20;//round down
    if (x >= 90) {
      return 100;
    } else if (x >= 70) {
      return 80;
    } else if (x >= 50) {
      return 60;
    } else if (x >= 30) {
      return 40;
    } else if (x >= 10) {
      return 20;
    } else if (x >= 0) {
      return 0;
    }
  }

  if (state.online) {
    if (checkifemptystateofdata()) {
      return (
        <div className="container">
          <div className="col">
            <div>
              <center>
                <img
                  src={require("./../../../images/simpleloading.gif")}
                  className="simpleloadingview"
                />
                <p>
                  <strong>Loading Circuit Diagram ...</strong>
                </p>
              </center>
            </div>
          </div>
        </div>
      );
    } else {
      if (state.surftype.toLowerCase().indexOf("amf") !== -1) {
        if (isfuelsaver) {
          //amf with fuel saver style={diagramFontSize}
          return (
            <div>
              <div className="container">
                <div className="row" style={diagramFontSize}>
                  <div className="col">
                    <div className="card text-center bg-light livediagramcards">
                      <div className="card-body ">
                        <table align="center">
                          <tbody>
                            <tr>
                              <td colSpan="2">
                                <strong>EDL (Électricité Du Liban)</strong>
                              </td>
                              <td colSpan="1">
                                <hr className="vr" />
                              </td>
                              <td colSpan="2">
                                <strong>Generator</strong>
                              </td>
                            </tr>
                            <tr>
                              <td colSpan="">
                                <strong
                                  className={
                                    state.uonload == 0 ? "redtext" : "greentext"
                                  }
                                >
                                  {state.uonload == 0 ? "INACTIVE" : "ACTIVE"}
                                </strong>
                              </td>
                              <td colSpan="3"></td>
                              <td colSpan="">
                                <strong
                                  className={
                                    state.gonload == 0 ? "redtext" : "greentext"
                                  }
                                >
                                  {state.gonload == 0 ? "INACTIVE" : "ACTIVE"}
                                </strong>
                              </td>
                            </tr>
                            <tr>
                              <td className="tr_inmode_table">
                                <figure>
                                  <img
                                    className="FStowercell"
                                    src={require("./../../../images/diagram/fuel_saver/tower.png")}
                                    title="Utility Tower"
                                    id="towercell"
                                  />
                                  <figcaption>
                                    <strong
                                      className={
                                        state.UPower > 0
                                          ? "bluetext"
                                          : "greentext"
                                      }
                                    >
                                      {state.UPower + " kW"}
                                    </strong>
                                  </figcaption>
                                </figure>
                              </td>
                              <td className="tr_inmode_table"></td>
                              <td className="tr_inmode_table"></td>
                              <td className="tr_inmode_table"></td>
                              <td className="tr_inmode_table">
                                <figure>
                                  <img
                                    className="FSgeneratorcell"
                                    src={require("./../../../images/diagram/fuel_saver/generator.png")}
                                    title="Generator"
                                    id="generatorcell"
                                  />
                                  <figcaption>
                                    <strong className="bluetext">
                                      {state.GPower + " kW"}
                                    </strong>
                                  </figcaption>
                                </figure>
                              </td>
                            </tr>
                            <tr>
                              <td className="tr_inmode_table" colSpan="2">
                                <div>
                                  <figure>
                                    <img
                                      className="FSloadcell"
                                      src={require("./../../../images/diagram/fuel_saver/home.png")}
                                      title="Load"
                                      style={{ height: "", width: "" }}
                                      id="loadcell"
                                    />
                                    <figcaption>
                                      <strong className="greentext">
                                        {state.Load + " kW"}
                                      </strong>
                                      <br />
                                      <strong>Consumption</strong>
                                    </figcaption>
                                  </figure>
                                </div>
                              </td>
                              <td className="tr_inmode_table">
                                <figure>
                                  <img
                                    className="FSinvertercell"
                                    src={require("./../../../images/diagram/fuel_saver/inverter.png")}
                                    style={{ height: "", width: "" }}
                                    title="Power Inverter"
                                    id="inverter"
                                  />
                                  <figcaption>
                                    <strong>&nbsp; &nbsp;</strong>
                                    <br />
                                    <strong>&nbsp; &nbsp;</strong>
                                  </figcaption>
                                </figure>
                              </td>
                              <td className="tr_inmode_table" colSpan="2">
                                <figure>
                                  <img
                                    className="FSpvcell"
                                    src={require("./../../../images/diagram/fuel_saver/pv.png")}
                                    style={{ height: "", width: "" }}
                                    title="Solar Panels"
                                    id="pv"
                                  />
                                  <figcaption>
                                    <strong className="bluetext">
                                      &nbsp;
                                      {state.PV + " kW"}
                                    </strong>
                                    <br />
                                    <strong>Solar Panels</strong>
                                  </figcaption>
                                </figure>
                              </td>
                            </tr>
                            <tr>
                              <td className="tr_inmode_table" colSpan="2"></td>
                              <td className="tr_inmode_table" colSpan="">
                                <figure>
                                  <img
                                    className="FSbatterycell"
                                    src={
                                      state.BatCurrent > 0
                                        ? require("./../../../images/diagram/fuel_saver/battery_charging.gif")
                                        : require("./../../../images/diagram/fuel_saver/battery_" +
                                            round20(state.BatCapacity) +
                                            ".png")
                                    }
                                    style={{ height: "", width: "" }}
                                    id="battery"
                                    title="Battery"
                                  />
                                  <figcaption>
                                    <strong
                                      className={
                                        state.BatCurrent > 0
                                          ? "greentext"
                                          : "bluetext"
                                      }
                                    >
                                      {state.BatCurrent + " kW"}
                                      <br />
                                      {"(" + state.BatCapacity + "% full)"}
                                    </strong>
                                    <br />
                                    <strong>Battery</strong>
                                  </figcaption>
                                </figure>
                              </td>
                              <td className="tr_inmode_table" colSpan="2"></td>
                            </tr>
                          </tbody>
                        </table>
                        <div></div>
                        {state.MinSoC != undefined &&
                          state.MinSoC != "" &&
                          state.BatCap != undefined &&
                          state.BatCap != "" &&
                          state.BatCapacity != 100 &&
                          state.BatCurrent != 0 && (
                            <strong
                              className={
                                state.BatCurrent > 0 ? "greentext" : "bluetext"
                              }
                            >
                              {calculateChargingOrDischargingTime()}
                            </strong>
                          )}
                      </div>
                      <strong>-{" " + state.siteid + " "}-</strong>
                      <WeatherWidget />
                      <br />
                    </div>
                  </div>
                </div>
              </div>
              <Chart mac={state.mac} from="COND05.jsx" />
            </div>
          );
        } else {
          return (
            <div className="row">
              <div className="col">
                <div className="card text-center bg-light livediagramcards">
                  <div className="card-body ">
                    <table align="center">
                      <tbody>
                        <tr>
                          <td colSpan="2">
                            <p
                              className="card-text font-weight-bold"
                              align="center"
                            >
                              Utlity Status: {state.ustatus}
                            </p>
                          </td>
                          <td>
                            <hr className="vr" />
                          </td>
                          <td colSpan="2">
                            <p
                              className="card-text font-weight-bold"
                              align="center"
                            >
                              Genset Status: {state.gstatus}
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td colSpan="">
                            <div>
                              <img
                                className="ledimage"
                                src={displayled("urunning")}
                                title="Utility Running Led"
                              />
                              <label>
                                &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                              </label>
                              <img
                                className="ledimage"
                                src={displayled("uonload")}
                                title="Utility Onload Led"
                              />
                            </div>
                          </td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td colSpan="">
                            <div>
                              <img
                                className="ledimage"
                                src={displayled("grunning")}
                                title="Genset Running Led"
                              />
                              <label>
                                &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                              </label>
                              <img
                                className="ledimage"
                                src={displayled("gonload")}
                                title="Genset Onload Led"
                              />
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td className="tr_inmode_table">
                            <img
                              className="towercell"
                              src={
                                state.urunning
                                  ? require("./../../../images/diagram/normal/tower_on.png")
                                  : require("./../../../images/diagram/normal/tower.png")
                              }
                              title="Utility Tower"
                            />
                          </td>
                          <td>
                            <img
                              src={
                                state.uonload
                                  ? require("./../../../images/diagram/normal/cont_close.png")
                                  : require("./../../../images/diagram/normal/cont_open.png")
                              }
                              className="contClose"
                              title="Contactor"
                            />
                          </td>
                          <td className="tr_inmode_table">
                            <img
                              className="loadcell"
                              src={require("./../../../images/diagram/normal/load.png")}
                              title="Load"
                            />
                          </td>
                          <td>
                            <img
                              src={
                                state.gonload
                                  ? require("./../../../images/diagram/normal/cont_close.png")
                                  : require("./../../../images/diagram/normal/cont_open.png")
                              }
                              className="contClose"
                              title="Contactor"
                            />
                          </td>
                          <td className="tr_inmode_table">
                            <img
                              className="generatorcell"
                              src={
                                state.grunning
                                  ? require("./../../../images/diagram/normal/g1_on.png")
                                  : require("./../../../images/diagram/normal/g1.png")
                              }
                              title="Generator"
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div></div>
                  </div>
                  <strong>-{" " + state.siteid + " "}-</strong>
                </div>
              </div>
            </div>
          );
        }
      } else {
        if (isfuelsaver) {
          //auto with fuel saver style={diagramFontSize}
          return (
            <div className="container">
              <div className="row" style={diagramFontSize}>
                <div className="col">
                  <div className="card text-center bg-light livediagramcards">
                    <div className="card-body ">
                      <table align="center">
                        <tbody>
                          <tr>
                            <td colSpan="2"></td>
                            <td colSpan="1">
                              <hr className="vr" />
                            </td>
                            <td colSpan="2">
                              <p
                                className="card-text font-weight-bold"
                                align="center"
                              >
                                Genset Status: {state.gstatus}
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td colSpan=""></td>
                            <td colSpan="3"></td>
                            <td colSpan="">
                              <div>
                                <img
                                  className="ledimage"
                                  src={displayled("grunning")}
                                  title="Genset Running Led"
                                />
                                <label>
                                  &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                                </label>
                                <img
                                  className="ledimage"
                                  src={displayled("gonload")}
                                  title="Genset Onload Led"
                                />
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td className="tr_inmode_table"></td>
                            <td className="tr_inmode_table"></td>
                            <td className="tr_inmode_table"></td>
                            <td className="tr_inmode_table"></td>
                            <td className="tr_inmode_table">
                              <figure>
                                <img
                                  className="FSgeneratorcell"
                                  src={require("./../../../images/diagram/fuel_saver/generator.png")}
                                  title="Generator"
                                  id="generatorcell"
                                />
                                <figcaption>
                                  <strong className="bluetext">
                                    {state.GPower + " kW"}
                                  </strong>
                                </figcaption>
                              </figure>
                            </td>
                          </tr>
                          <tr>
                            <td className="tr_inmode_table" colSpan="2">
                              <div>
                                <figure>
                                  <img
                                    className="FSloadcell"
                                    src={require("./../../../images/diagram/fuel_saver/home.png")}
                                    title="Load"
                                    style={{ height: "", width: "" }}
                                    id="loadcell"
                                  />
                                  <figcaption>
                                    <strong className="greentext">
                                      {state.Load + " kW"}
                                    </strong>
                                    <br />
                                    <strong>Consumption</strong>
                                  </figcaption>
                                </figure>
                              </div>
                            </td>
                            <td className="tr_inmode_table">
                              <figure>
                                <img
                                  className="FSinvertercell"
                                  src={require("./../../../images/diagram/fuel_saver/inverter.png")}
                                  style={{ height: "", width: "" }}
                                  title="Power Inverter"
                                  id="inverter"
                                />
                                <figcaption>
                                  <strong>&nbsp; &nbsp;</strong>
                                  <br />
                                  <strong>&nbsp; &nbsp;</strong>
                                </figcaption>
                              </figure>
                            </td>
                            <td className="tr_inmode_table" colSpan="2">
                              <figure>
                                <img
                                  className="FSpvcell"
                                  src={require("./../../../images/diagram/fuel_saver/pv.png")}
                                  style={{ height: "", width: "" }}
                                  title="Solar Panels"
                                  id="pv"
                                />
                                <figcaption>
                                  <strong className="bluetext">
                                    {state.PV + " kW"}
                                  </strong>
                                  <br />
                                  <strong>Solar Panels</strong>
                                </figcaption>
                              </figure>
                            </td>
                          </tr>
                          <tr>
                            <td className="tr_inmode_table" colSpan="2"></td>
                            <td className="tr_inmode_table" colSpan="">
                              <figure>
                                <img
                                  className="FSbatterycell"
                                  src={
                                    state.BatCurrent > 0
                                      ? require("./../../../images/diagram/fuel_saver/battery_charging.gif")
                                      : require("./../../../images/diagram/fuel_saver/battery_" +
                                          round20(state.BatCapacity) +
                                          ".png")
                                  }
                                  style={{ height: "", width: "" }}
                                  id="battery"
                                  title="Battery"
                                />
                                <figcaption>
                                  <strong
                                    className={
                                      state.BatCurrent > 0
                                        ? "greentext"
                                        : "bluetext"
                                    }
                                  >
                                    {state.BatCurrent +
                                      " kW (" +
                                      state.BatCapacity +
                                      "% full)"}
                                  </strong>
                                  <br />
                                  <strong>Battery</strong>
                                </figcaption>
                              </figure>
                            </td>
                            <td className="tr_inmode_table" colSpan="2"></td>
                          </tr>
                        </tbody>
                      </table>
                      <div></div>
                    </div>
                    <strong>-{" " + state.siteid + " "}-</strong>
                    <br />
                    <footer>
                      Designed And Developed by{" "}
                      <a
                        href="http://www.sascontrollers.com"
                        target="_blank"
                        title="www.sascontrollers.com"
                        bis_skin_checked="1"
                      >
                        S.&A.S.Co.Ltd
                      </a>
                    </footer>
                  </div>
                </div>
              </div>
            </div>
          );
        } else {
          return (
            <div className="row">
              <div className="col">
                <div className="card text-center bg-light livediagramcards">
                  <div className="card-body ">
                    <table align="center">
                      <tbody>
                        <tr>
                          <td colSpan="3">
                            <p
                              className="card-text font-weight-bold"
                              align="center"
                            >
                              Genset Status: {state.gstatus}
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td className="tr_inmode_table">
                            <img
                              className="loadcell"
                              src={require("./../../../images/diagram/normal/load.png")}
                              title="Load"
                            />
                          </td>
                          <td className="tr_inmode_table">
                            <img
                              src={
                                state.gonload
                                  ? require("./../../../images/diagram/normal/cont_close.png")
                                  : require("./../../../images/diagram/normal/cont_open.png")
                              }
                              className="contClose"
                              title="Contactor"
                            />
                          </td>
                          <td className="tr_inmode_table">
                            <div>
                              <img
                                className="ledimage"
                                src={displayled("grunning")}
                                title="Genset Running Led"
                              />
                              <label>
                                &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                              </label>
                              <img
                                className="ledimage"
                                src={displayled("gonload")}
                                title="Genset Onload Led"
                              />
                            </div>
                            <img
                              className="generatorcell"
                              src={
                                state.grunning
                                  ? require("./../../../images/diagram/normal/g1_on.png")
                                  : require("./../../../images/diagram/normal/g1.png")
                              }
                              title="Generator"
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div></div>
                  </div>
                  <strong>-{" " + state.siteid + " "}-</strong>
                </div>
              </div>
            </div>
          );
        }
      }
    }
  } else {
    //offline display
    return (
      <div className="container">
        <div className="col">
          <div>
            <center>
              <img
                src={require("./../../../images/offline.gif")}
                className="simpleloadingview"
              />
              <p>
                <strong>
                  The site appears to be offline, try to refresh the page in 5
                  minutes.
                </strong>
              </p>
            </center>
          </div>
        </div>
      </div>
    );
  }
};
export default COND05;
